<div class="min-h-screen bg-gradient-to-b from-vivid-royal-50 to-white dark:from-crayola-blue-900 dark:to-crayola-blue-800 flex items-center justify-center p-6">
  <div class="max-w-md w-full bg-white dark:bg-crayola-blue-800 rounded-2xl shadow-xl p-8 text-center space-y-5">

    <!-- Logo -->
    <img src="./assets/logos/energo_logo_dark.svg" class="h-10 mx-auto" />

    @if(paymentStatus === 'success') {
      <!-- Éxito -->
      <div class="w-20 h-20 mx-auto rounded-full bg-green-100 dark:bg-green-900/30 flex items-center justify-center">
        <i class="pi pi-check text-4xl text-green-500"></i>
      </div>
      <h1 class="text-xl font-bold text-vivid-royal-800 dark:text-white">¡Pago exitoso!</h1>
      <p class="text-sm text-vivid-royal-500 dark:text-vivid-royal-200">
        Su transacción fue procesada correctamente. Se envió un comprobante a su correo electrónico registrado.
      </p>

      <div class="bg-vivid-royal-50 dark:bg-vivid-royal-900 rounded-lg px-4 py-3">
        <p class="text-xs text-vivid-royal-400">Serás redirigido automáticamente en</p>
        <p class="text-2xl font-bold text-vivid-royal-700 dark:text-white">{{ countdown }}s</p>
      </div>

      <button pButton label="Ir al portal ahora" icon="pi pi-arrow-right" iconPos="right"
        class="p-button-sm w-full" (click)="goToDashboard()"></button>

    } @else {
      <!-- Error -->
      <div class="w-20 h-20 mx-auto rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center">
        <i class="pi pi-times text-4xl text-red-500"></i>
      </div>
      <h1 class="text-xl font-bold text-vivid-royal-800 dark:text-white">Pago no procesado</h1>
      <p class="text-sm text-vivid-royal-500 dark:text-vivid-royal-200">
        No pudimos procesar su pago. Esto puede deberse a fondos insuficientes, datos incorrectos o un problema temporal.
      </p>

      <div class="text-sm text-red-700 bg-red-100 border border-red-300 rounded-lg px-3 py-2 dark:bg-red-900/20 dark:border-red-800 dark:text-red-300">
        Si el problema persiste, comuníquese con atención a clientes.
      </div>

      <div class="flex gap-3">
        <button pButton label="Reintentar" icon="pi pi-refresh" class="p-button-sm p-button-outlined flex-1" (click)="goToPayments()"></button>
        <button pButton label="Ir al portal" icon="pi pi-home" class="p-button-sm flex-1" (click)="goToDashboard()"></button>
      </div>
    }
  </div>
</div>
